"use strict";
/**
 * Created by jonas on 2020-09-09.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameMode = void 0;
class GameMode {
}
exports.GameMode = GameMode;
GameMode.NORMAL = "NORMAL";
GameMode.RESPIN = "RESPIN";
GameMode.FREESPIN = "FREESPIN";
GameMode.FREESPIN_SUPER = "FREESPIN_SUPER";
GameMode.GAMBLE = "GAMBLE";
//# sourceMappingURL=GameMode.js.map